import makeLookupModal from "../../UI/LookupModal/LookupModal";
import LmsIntegrationLookup from "./LmsIntegrationLookup";
const LmsIntegrationLookupModal = makeLookupModal(LmsIntegrationLookup, {
    pluralEntityName: "Lms Integrations",
});
export default LmsIntegrationLookupModal;
